export const register = {
    title: '登记',
    passwordLabel: '密码',
    confirmPassword: '重新输入密码',
    buttonRegister: '登记',
    confirmPasswordLabel: '重新输入密码',
    policy1: '我同意',
    policy2: '条款和条件',
    and: '和',
    policy3: '隐私政策。',
    backToLogin: '返回登录',
    contentAfterRegister:
        '恭喜您注册成功！ 请检查您的电子邮件以验证您的帐户。 如果您在收件箱中没有看到验证邮件，请检查您的垃圾邮件文件夹。',
};
